import * as React from "react";
import type { SVGProps } from "react";
const SvgLevelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="level_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M448 512a64 64 0 1 0 128 0 64 64 0 0 0-128 0zm-79.147 42.667H85.333a42.667 42.667 0 1 1 0-85.334h283.52a149.419 149.419 0 0 1 286.294 0h283.52a42.667 42.667 0 1 1 0 85.334h-283.52a149.419 149.419 0 0 1-286.294 0z"
    />
  </svg>
);
export default SvgLevelIcon;
